var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-circular',{class:_vm.extraClass,attrs:{"size":25,"width":3,"color":"secondary","indeterminate":""}})}
var staticRenderFns = []

export { render, staticRenderFns }